import { getApi } from 'util/api';

// eslint-disable-next-line import/prefer-default-export
export const loadFlags = ({ flagName, multi }) => {
  const queryParams = new URLSearchParams({ key: flagName });
  if (multi !== undefined && multi) {
    queryParams.append('multi', multi);
  }
  return getApi(`/auth/flags/flag?${queryParams.toString()}`);
};
